import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "/root/workspace/__flow_work/__flow_builds/31ddae26-918c-4c5a-957f-539a4cbf5f74/workspace/streffy-middle-office_CyFO/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var basePre = 'coupon-center';
var meta = {
  auth: true,
  closable: true,
  showMenu: false,
  refresh: true,
  activePath: "/".concat(basePre, "/coupon-template")
};
export default [{
  path: "/".concat(basePre, "/card-template-detail/:type/:id"),
  title: '礼品卡模板',
  name: "card-template-detail",
  meta: _objectSpread(_objectSpread({}, meta), {}, {
    activePath: "/".concat(basePre, "/card-template"),
    title: '礼品卡模板'
  }),
  component: "pages/".concat(basePre, "/card-template/detail.vue")
},
// {
//     path: `/${basePre}/card-template-detail/:id`,
//     title: '礼品卡模板详情',
//     name: `card-template-detail`,
//     meta: {
//         auth: true,
//         closable: true,
//         showMenu: false,
//         activePath: `/${basePre}/card-template`,
//         title: '礼品卡模板详情'
//     },
//     component: `pages/${basePre}/card-template/detail.vue`
// },
{
  path: "/".concat(basePre, "/card-exchange-detail/:type/:id"),
  title: '兑换投放',
  name: "card-exchange-detail",
  meta: _objectSpread(_objectSpread({}, meta), {}, {
    activePath: "/".concat(basePre, "/card-exchange"),
    title: '兑换投放'
  }),
  component: "pages/".concat(basePre, "/card-exchange/detail.vue")
},
// {
//     path: `/${basePre}/card-exchange-detail/:id`,
//     title: '兑换投放详情',
//     name: `card-exchange-detail`,
//     meta: {
//         ...meta,
//         activePath: `/${basePre}/card-exchange`,
//         title: '兑换投放详情'
//     },
//     component: `pages/${basePre}/card-exchange/detail.vue`
// },
{
  path: "/".concat(basePre, "/card-theme-detail/:type/:id"),
  title: '礼品卡主题',
  name: "card-theme-detail",
  meta: _objectSpread(_objectSpread({}, meta), {}, {
    activePath: "/".concat(basePre, "/card-theme"),
    title: '礼品卡主题'
  }),
  component: "pages/".concat(basePre, "/card-theme/detail.vue")
},
// {
//     path: `/${basePre}/card-theme-detail/:id`,
//     title: '礼品卡主题详情',
//     name: `card-theme-detail`,
//     meta: {
//         ...meta,
//         activePath: `/${basePre}/card-theme`,
//         title: '礼品卡主题详情'
//     },
//     component: `pages/${basePre}/card-theme/detail.vue`
// },
{
  path: "/".concat(basePre, "/card-shelves-detail/:type/:id"),
  title: '礼品卡货架',
  name: "card-shelves-detail",
  meta: _objectSpread(_objectSpread({}, meta), {}, {
    activePath: "/".concat(basePre, "/card-shelves"),
    title: '礼品卡货架'
  }),
  component: "pages/".concat(basePre, "/card-shelves/detail.vue")
}
// {
//     path: `/${basePre}/card-shelves-detail/:id`,
//     title: '礼品卡货架详情',
//     name: `card-shelves-detail`,
//     meta: {
//         ...meta,
//         activePath: `/${basePre}/card-shelves`,
//         title: '礼品卡货架详情'
//     },
//     component: `pages/${basePre}/card-shelves/detail.vue`
// }
];